import React, { useState } from "react";
import styled from "@emotion/styled";
import Arrow from "../../assets/icons/Arrow.png";

export const ExpandableTab = ({ label, children }) => {
  const [active, setActive] = useState(false);
  return (
    <>
      <TabContainer onClick={() => setActive(!active)}>
        <TabLabel>
          <b>{label}</b>
        </TabLabel>
        <TabArrowContainer>
          <TabArrow active={active} src={Arrow} />
        </TabArrowContainer>
      </TabContainer>
      <TabContent active={active}>{children}</TabContent>
    </>
  );
};

const TabContainer = styled.div`
  height: 42px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: #04803b;
  border-radius: 8px;

  margin-bottom: 4px;

  :hover {
    cursor: pointer;
  }
`;

const TabArrowContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TabArrow = styled.img`
  width: 12px;
  height: 6px;

  margin: 0 30px 0 10px;
  transform: rotate(${(props) => (!props.active ? "180deg" : "0deg")});
  transition: 0.5s;
`;

const TabLabel = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-size: 16px;
  line-height: 26px;

  text-align: center;

  color: #ffffff;

  margin-left: 24px;
`;

const TabLabelOpen = styled(TabLabel)`
  display: ${(props) => (!props.active ? "block" : "none")};
`;

const TabContent = styled.div`
  display: ${(props) => (props.active ? "block" : "none")};
  background-color: #04803b;
  margin-top: -10px;
  border-radius: 0 0 8px 8px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-top: 4px;
  color: white;
`;
